import PropertiesService from "./services";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    loading: false,
  },
  getters: {
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val;
    },
  },
  actions: {
    async addProperty({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await PropertiesService.addProperty(payload);
        commit("setLoading", false);

        if (hasError(res.status)) {
          throw res.statusText;
        }
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      }
    },
    async updateProperty({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await PropertiesService.updateProperty(payload);
        commit("setLoading", false);

        if (hasError(res.status)) {
          throw res.statusText;
        }
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      }
    },
    async deleteProperty({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await PropertiesService.deleteProperty(payload);
        commit("setLoading", false);

        if (hasError(res.status)) {
          throw res.statusText;
        }
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      }
    },
  },
};
